import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrangeForward = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.14252 6.07165C5.85366 6.36852 5.86017 6.84335 6.15704 7.13221C6.45392 7.42106 6.92875 7.41456 7.2176 7.11768L9.25001 5.02884L9.25 12.7366C9.25 13.1508 9.58579 13.4866 10 13.4866C10.4142 13.4866 10.75 13.1508 10.75 12.7366L10.75 5.02884L12.7824 7.11768C13.0713 7.41456 13.5461 7.42106 13.843 7.13221C14.1399 6.84335 14.1464 6.36852 13.8575 6.07165L10.5375 2.6595C10.3964 2.51439 10.2025 2.43252 10 2.43252C9.79753 2.43252 9.60366 2.51439 9.46246 2.6595L6.14252 6.07165ZM2.3698 11.6185L7.9527 8.8271V10.5041L3.48784 12.7366L9.88819 15.9368C9.95858 15.9719 10.0414 15.9719 10.1118 15.9368L16.5122 12.7366L12.0473 10.5041V8.8271L17.6302 11.6185C18.5515 12.0792 18.5515 13.394 17.6302 13.8546L10.7826 17.2784C10.2899 17.5247 9.71005 17.5247 9.21737 17.2784L2.3698 13.8546C1.4485 13.394 1.44849 12.0792 2.3698 11.6185Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ArrangeForward
